import { TeacherOrderList } from "./Order.list";

const resource = {
    list: TeacherOrderList
}

export default resource